<div>
  <ng-container>
    <h2 mat-dialog-title class="model-title">{{ preconnectFormFields.title }}</h2>
    <mat-dialog-content>
      <mat-dialog-content class="description-content" [innerHTML]="preconnectFormFields.description">
      </mat-dialog-content>
      <div class="sync-settings" [formGroup]="syncSettingsForm">
        <div *ngFor="let setting of getSyncSettings()">
          <mat-card *ngIf="!setting.hidden" appearance="outlined" class="mat-card-margin">
            <mat-card-content>
              <div class="mat-card-content">
                <mat-checkbox [formControlName]="setting.id"></mat-checkbox>
                <div class="mat-card-content-column">
                  <div class="title">
                    {{ setting.label }}
                  </div>
                  <div class="sub-title">
                    {{ setting.hintText }}
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <platform-integration-action-type [actions]="preconnectFormFields.actions" (actionClicked)="handleAction($event)">
      </platform-integration-action-type>
    </mat-dialog-actions>
  </ng-container>
</div>
